module.exports = __webpack_public_path__ + "img/cyberDictation.08beae33.svg";